export interface BillingLockWaiverSource {
  billing_exempt?: boolean | null;
  billing_override_until?: string | null;
}

export function isBillingLockWaived(
  org: BillingLockWaiverSource | null | undefined,
  now: Date = new Date(),
): boolean {
  if (!org) return false;
  if (org.billing_exempt === true) return true;
  if (!org.billing_override_until) return false;
  const until = new Date(org.billing_override_until).getTime();
  return Number.isFinite(until) && until > now.getTime();
}
